import React, { useMemo } from 'react';
import { getTreeLayoutConfig, TreeLayoutTypeEnum, } from './TreeLayoutConfig';
import useLayoutDirection from '../../utils/Translations/useLayoutDirection';
const TreeContentWrapper = ({ treeLayoutType = TreeLayoutTypeEnum.TREE_TABBED_PAGE, EditComponent = null, isNodeEditVisible = true, children, }) => {
    const { isLayoutRTL } = useLayoutDirection();
    const wrapperClasses = useMemo(() => getTreeLayoutConfig(treeLayoutType), [
        treeLayoutType,
    ]);
    if (isNodeEditVisible && EditComponent) {
        const treeNode = (<div className={wrapperClasses.treeClassName}>{children}</div>);
        const editNode = (<div className={wrapperClasses.editNodeClassName}>{EditComponent}</div>);
        return (<div className="row">
        {isLayoutRTL ? editNode : treeNode}
        {isLayoutRTL ? treeNode : editNode}
      </div>);
    }
    return (<div className="row">
      <div className="col-xs-12">{children}</div>
    </div>);
};
export default TreeContentWrapper;
